exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".select--aCEvx {\n\tpadding-bottom: 20px;\n\twidth: 100%;\n}", ""]);

// Exports
exports.locals = {
	"select": "select--aCEvx"
};